import
  React
from 'react';

import {
  Images,
  Messages,
  Logger,
  getQueryParameterByName,
  isValidProviderResult,
} from 'common';

import {
  Button,
  Loader,
} from 'common/components';

import {
  withCommon,
} from 'common/hocs';

import {
  HeaderText,
  SubHeaderText,
  TickImage,
} from './accountRemoveStyled';

import {
  Container,
} from '../identityStyled';

import {
  IdentityProvider,
} from 'providers';

class AccountRemoveUI extends React.Component {

  state = {
    isLoading: true,
    showError: false,
    errorMessage: Messages.TechnicalError,
  };

  token = getQueryParameterByName('t');
  type = getQueryParameterByName('type');
  email = getQueryParameterByName('email');

  onLoginClick = () => {
    this.props.common.navigate('/identity/login');
  };

  onRetryClick = () => {
    window.location.reload();
  };

  componentDidMount() {

    IdentityProvider
      .removeAccount(
        this.email,
        this.type,
        this.token,
      )
      .then(ret => {

        if (!isValidProviderResult(ret)) {

          Logger.error(ret.message || Messages.TechnicalError);

          this.setState({
            showError: true,
            errorMessage: ret.message || Messages.TechnicalError,
            isLoading: false,
          });

          return;
        }

        this.setState({
          isLoading: false,
        });
      })
      .catch(e => {

        Logger.error(e);

        this.setState({
          showError: true,
          errorMessage: Messages.TechnicalError,
          isLoading: false,
        });
      });
  }

  render () {

    const heading = this.type === 'deactivate'
      ? 'Account deactivated'
      : 'Account deleted';

    const subHeading = this.type === 'deactivate'
      ? 'You have successfully deactivated your account.'
      : 'You have successfully deleted your account.';

    return (

      <Container>

        { this.state.isLoading &&

          <Loader/>
        }

        { !this.state.isLoading && this.state.showError &&

          <React.Fragment>

            <HeaderText>{`We were unable to ${this.type} your account`}</HeaderText>

            <SubHeaderText>{this.state.errorMessage}</SubHeaderText>

            <Button
              text={'RETRY'}
              onClick={this.onRetryClick}
            />

          </React.Fragment>
        }

        { !this.state.isLoading && !this.state.showError &&

          <React.Fragment>

            <TickImage
              src={Images.Icons.CircleTick}
            />

            <HeaderText>{heading}</HeaderText>

            <SubHeaderText>{subHeading}</SubHeaderText>

            <Button
              text={'GO TO LOGIN'}
              onClick={this.onLoginClick}
            />

          </React.Fragment>
        }

      </Container>
    );
  }
}

export const AccountRemove = withCommon(
  AccountRemoveUI, {
    showHeader: false,
    showSideMenu: false,
    requiresAuth: false,
    addExitSafeguard: false,
  }
);
